// The entitlement seam — "does this WiserWeb account have a plan for THIS app?"
//
// One WiserWeb account spans the whole suite, but access to a given app is gated by a plan/entitlement. There
// is no shared entitlement service yet (wiser-accounts is identity-only), so this is a PLUGGABLE HOOK each
// app supplies: check your own subscription data (or a future shared billing service). It runs right after a
// successful login, BEFORE the app trades the session for its own — so an unentitled user is sent to onboard
// / plan-selection instead of into the app.
//
// Default = always entitled, so auth-only apps that don't gate on a plan can ignore it entirely.
import type { UnlockedAccount } from './account';

export type EntitlementResult =
  | { entitled: true }
  /** Not entitled — send the user here to pick a plan / onboard. */
  | { entitled: false; onboardUrl: string };

export type EntitlementCheck = (account: UnlockedAccount) => Promise<EntitlementResult> | EntitlementResult;

/** The default: every authenticated account is allowed in. */
export const alwaysEntitled: EntitlementCheck = () => ({ entitled: true });
